export default (id = 'quiz-widget') => {
  const bodyList = document.querySelector('body')
  const config = {
    childList: true,
    subtree: true
  }
  const mountedElem = document.querySelector(`#${id}`)

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(() => {
      if (mountedElem.nextElementSibling && !mountedElem.nextElementSibling.classList.contains('dp__menu_index')) {
        bodyList.append(mountedElem)
      }
    })
  })

  observer.observe(bodyList, config)
}
